import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface SsoProvider {
  url: string
  provider: string
}

export async function getSsoProvider(domain: string): Promise<SsoProvider> {
  const resp = await api.get<SsoProvider>(
    env.VITE_SSO_URL,
    `/auth/domain/${domain}`,
  )

  return resp.body
}
